import { WalletDetailEnum } from 'app/models';

export class WalletDetail {
    public static WalletDetailList: Array<any> = [
        { name: 'Gcash', value: WalletDetailEnum.Gcash },
        { name: 'Paymaya', value: WalletDetailEnum.Paymaya },
        { name: 'Paymongo', value: WalletDetailEnum.Paymongo },
        { name: 'Paypal', value: WalletDetailEnum.Paypal },
        { name: 'WeChat Pay', value: WalletDetailEnum.WeChatPay },
    ];
}
